import React, { useRef, useEffect } from 'react';
import { HistoryItem } from '../types';

interface TextInputProps {
  text: string;
  onTextChange: (text: string) => void;
  onTextBlur: () => void;
  historyItems: HistoryItem[];
  showHistoryMenu: boolean;
  setShowHistoryMenu: (show: boolean) => void;
  currentLabel: string | null;
}

const TextInput: React.FC<TextInputProps> = ({
  text,
  onTextChange,
  onTextBlur,
  historyItems,
  showHistoryMenu,
  setShowHistoryMenu,
  currentLabel,
}) => {
  const historyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (historyRef.current && !historyRef.current.contains(event.target as Node)) {
        setShowHistoryMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setShowHistoryMenu]);

  return (
    <div className="bg-white rounded-xl shadow-sm p-3 mb-1 relative" ref={historyRef}>
      <div className="flex justify-between items-center mb-1">
        <div className="flex items-center gap-1.5 min-w-0">
          <label className="text-xs text-gray-500 shrink-0">练习文字</label>
          {currentLabel && currentLabel !== text && (
            <span className="text-xs text-[#3B82F6] truncate min-w-0" title={currentLabel}>
              {currentLabel}
            </span>
          )}
        </div>
        <button
          onClick={() => setShowHistoryMenu(!showHistoryMenu)}
          className="text-xs text-[#3B82F6] flex items-center"
        >
          历史记录 <i className="fa fa-caret-down ml-1"></i>
        </button>
      </div>
      <input
        type="text"
        placeholder="输入要练习的汉字，例如：天地玄黄"
        value={text}
        onChange={(e) => onTextChange(e.target.value)}
        onBlur={onTextBlur}
        className="w-full border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/50 focus:border-[#3B82F6]"
      />

      {showHistoryMenu && (
        <div className="absolute z-50 right-4 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-100 py-1">
          {historyItems.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                onTextChange(item.text);
                setShowHistoryMenu(false);
              }}
              className="px-3 py-2 text-sm hover:bg-gray-50 cursor-pointer"
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TextInput;
